module.exports = __webpack_public_path__ + "static/media/demo-store-2.ca2cc108.jpg";